import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { millisecondsInSecond } from 'date-fns';

import { appStore } from '@kaltura-ott/tvpil-shared';

import { useLiveAnnouncer } from 'hooks/common/useLiveAnnouncer';

import styles from './CheckConnectionMessage.module.scss';

function CheckConnectionMessage({ timerSec }: { timerSec: number | undefined }) {
  const intl = useIntl();
  const { checkInterval } = appStore.getConnectivityConfiguration();
  const checkIntervalInSeconds = checkInterval / millisecondsInSecond;
  const { announce, LiveRegion } = useLiveAnnouncer();
  const message = intl.formatMessage(
    timerSec! < 1 ? { defaultMessage: 'We are trying to reconnect now. Please wait...', id: 'Error.autoRecoveryMessage' } :
      { defaultMessage: `We are trying to reconnect in ${timerSec} sec. Please wait...`, id: 'Error.checkConnectionMessage' }, {value: timerSec}
  );

  useEffect(() => {
    // TODO: should be covered by units
    if (!timerSec) return;

    if (timerSec % (checkIntervalInSeconds / 2) === 0 || timerSec < 1) {
      announce(message);
    }
  }, [announce, timerSec]);

  if (timerSec === undefined) {
    return null;
  }

  return (
    <div className={styles.checkConnectionMsg}>
      {message}
      <LiveRegion />
    </div>
  );
}

export default CheckConnectionMessage;
